import React, { useContext } from 'react';
import * as S from './styled';
import { useSnackbar } from 'notistack';
import Form from '../..';
import {
  defaultBlurTaxForm,
  defaultTaxForm,
} from '../../../../store/invoice/utils';
import { ExportContext } from '../../../../provider/ExportProvider';
import { formatBRL, formatCents } from '../../../../store/masks';

export default function FormTaxUpdate() {
  const {
    taxes,
    getInvoice,
    setInvoice,
    updateTax,
    setModal,
    getFormMessage,
    validateForm,
  } = useContext(ExportContext)!.controllers.tax;
  const { enqueueSnackbar } = useSnackbar();

  const getForm = <T extends keyof TaxForm>(field: T) =>
    getInvoice(`forms.taxes.update.${field}`);

  const setForm = <
    T extends keyof TaxForm,
    V extends DeepType<InvoiceState, `forms.taxes.update.${T}`>,
  >(
    field: T,
    value: V,
  ) => setInvoice(`forms.taxes.update.${field}`, value);

  const blurField = (field: keyof TaxForm) => () => {
    setInvoice(`blur.taxes.update.${field}`, true);
  };

  const clearForm = () => {
    const tax = taxes.find(
      ({ id }) => getInvoice('forms.taxes.update').id === id,
    )!;
    setInvoice(`forms.taxes.update`, {
      id: tax.id,
      name: tax.name,
      description: tax.description,
      value: tax.value,
    });
    setInvoice(`blur.taxes.update`, defaultBlurTaxForm());
  };

  const messages = getFormMessage('taxes.update');

  const [loading, setLoading] = React.useState(false);
  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    validateForm('taxes.update')
      .then(() => {
        setLoading(true);
        updateTax()
          .then(() => {
            enqueueSnackbar('Taxa atualizada com sucesso', {
              variant: 'success',
            });
            setInvoice('forms.taxes.update', { id: 0, ...defaultTaxForm() });
            setModal('single.updateTax', false);
          })
          .catch(() => {
            enqueueSnackbar('Houve uma falha ao atualizar a taxa', {
              variant: 'error',
            });
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch(() => {
        enqueueSnackbar('Verifique a validade dos campos', {
          variant: 'error',
        });
      });
  };

  return (
    <S.Form
      style={{
        maxHeight: '80vh',
      }}
      onSubmit={onSubmit}
    >
      <S.Body>
        <S.Grid>
          <Form.Input
            label="Nome"
            value={getForm('name')}
            onChange={(e) => setForm('name', e.target.value)}
            error={messages.name}
            onBlur={blurField('name')}
          />
          <Form.Input
            label="Descrição"
            value={getForm('description')}
            onChange={(e) => setForm('description', e.target.value)}
          />
          <Form.Input
            label="Valor"
            value={getForm('value')}
            onChange={(e) => setForm('value', +e.target.value)}
            error={messages.value}
            onBlur={blurField('value')}
            mask={formatBRL}
            unmask={formatCents}
          />
        </S.Grid>
      </S.Body>
      <S.Actions>
        <Form.Button type="button" onClick={clearForm}>
          Limpar
        </Form.Button>
        <Form.Button loading={loading}>Atualizar</Form.Button>
      </S.Actions>
    </S.Form>
  );
}
